import { render } from "./MsgSucess.vue?vue&type=template&id=3724959d&scoped=true"
import script from "./MsgSucess.vue?vue&type=script&lang=js"
export * from "./MsgSucess.vue?vue&type=script&lang=js"

import "./MsgSucess.vue?vue&type=style&index=0&id=3724959d&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3986129723/src/app-csd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3724959d"]])

export default __exports__